import { axiosApi as axios } from "../helpers/axiosApi";
import { getCookie } from './helpers';

const CLIENTS_API = "/clients/";

export const getAllClients = (params) => {
  return axios.get(CLIENTS_API, {
    params: params, headers: {"Authorization": `Bearer ${getCookie('access')}`}
  }).then(res => {return res.data;});
};

export const deleteClient = (id) => {
  return axios.delete(`${CLIENTS_API}${id}/`, {
    headers: { "Authorization": `Bearer ${getCookie('access')}` }
  }).then(res => {return res;});
};

export const addClient = (registry) => {
  return axios.post(CLIENTS_API, registry, {
    headers: { "Authorization": `Bearer ${getCookie('access')}` }
  }).then(res => { return res.data; });
};


export const updateClient = (id, body) => {
  return axios.put(`${CLIENTS_API}${id}/`, body, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
};

export const getClientAdditionalInfo = (clientName) => {
  return axios.get(`${CLIENTS_API}additional-info/`, {
    params: { name: clientName },
    headers: { "Authorization": `Bearer ${getCookie('access')}` }
  }).then(res => res.data?.data?.additional_info || {});
};
